import styles from 'styles/add/Progress.module.css'

const Progress = ({ progress }) =>
    <div className={styles.bar}>
        { progress !== null && <div style={{width:`${progress}%`}} /> }
    </div>

export default Progress